// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"_33974c2b58--spinner--uXgOG","circle-spin":"_33974c2b58--circle-spin--HhIQz"};